<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner.png">
        <div class="box-font">会员中心</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <leftmenu :value='Id' :list='navlist' @datashow=listshow></leftmenu>
          <!--登录-->
          <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div style="margin-left: 20px;padding:20px;width:100%; border: 1px solid #CCCCCC;">
          <el-form ref="infoForm" :model="infoForm" label-width="135px">
            <el-row align="middle" class="warp">       
              <el-col  v-if="infoForm.uStatus == -1">
                <el-form-item style="color: red;" label="审核备注：">
                  <span>{{infoForm.approveRemark}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户名：">
                  <el-input v-model="infoForm.uLoginName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="密码：">
                  <div style="display: flex;">
                  <el-input v-model="infoForm.uLoginPWD"></el-input>
                  <el-button  @click="updatePWD" style="background-color: #409EFF;color: white;">修改密码</el-button>
                </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="密码问题：">
                  <el-input v-model="infoForm.SecurityQuestion"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="密码答案：">
                  <el-input v-model="infoForm.SecretAnswer"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="用户类型：" trigger="blur" prop="RegisterType">
                  <el-radio v-model="infoForm.RegisterType" label="0">一般供货商</el-radio>
                  <el-radio v-model="infoForm.RegisterType" label="1">协议供货商</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户角色：">
                  <el-radio v-model="infoForm.RegisterRole" label="1">询价</el-radio>
                  <el-radio v-model="infoForm.RegisterRole" label="2">竞价</el-radio>
                </el-form-item>
              </el-col> -->
              <el-col>
                <el-form-item label="地区：">
                  <el-input v-model="infoForm.Area"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位名称：" trigger="blur">
                  <el-input v-model="infoForm.CompanyName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地址：">
                  <el-input v-model="infoForm.addr"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮编：">
                  <el-input v-model="infoForm.PostalCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="网址：">
                  <el-input v-model="infoForm.Website"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人：">
                  <el-input v-model="infoForm.Contacts"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话：">
                  <el-input v-model="infoForm.Telphone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机：">
                  <el-input v-model="infoForm.Phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="传真：">
                  <el-input v-model="infoForm.Fax"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="总协调人：">
                  <el-input v-model="infoForm.Coordinator"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话：">
                  <el-input v-model="infoForm.CoordinatorPhone"></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="email：">
                  <el-input v-model="infoForm.Email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开户行：">
                  <el-input v-model="infoForm.Bank"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="帐号：">
                  <el-input v-model="infoForm.BankNO"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="营业执照有效期：">
                  <el-date-picker v-model="infoForm.LicenseValid" type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="营业执照号码：">
                  <el-input v-model="infoForm.LicenseNO"></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="营业执照：">
                  <el-image style="width: 100px; height: 100px" :src="infoForm.Upload_1"></el-image>
                  <el-upload v-show="infoForm.uStatus != 1"
                  class="upload-demo"
                  action=""
                  ref="Pic_Upload_1"
                  :http-request="Pic_Upload_1"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleAvatarSuccess"
                  name="Files"
                  accept=".jpeg,.png,.jpg,.gif,.BMP"
                  :limit="1"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">(文件大小&lt;200k 格式.jpg或.gif)</div>
                </el-upload>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="法人代表身份证：">
                  <el-image  style="width: 100px; height: 100px" :src="infoForm.Upload_4"></el-image>
                  <el-upload v-show="infoForm.uStatus != 1"
                  class="upload-demo"
                  action=""
                  ref="Pic_Upload_4"
                  :http-request="Pic_Upload_4"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleAvatarSuccess2"
                  name="Files"
                  accept=".jpeg,.png,.jpg,.gif,.BMP"
                  :limit="1"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">(文件大小&lt;200k 格式.jpg或.gif)</div>
                </el-upload>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="其他附件：">
                  <span >{{ infoForm.Upload_5 }}</span>
                  <el-upload v-show="infoForm.uStatus != 1"
                  class="upload-demo"
                  action=""
                  :http-request="file_Upload_5"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleAvatarSuccess3"
                  name="Files"
                  accept=".zip,.rar,.cab,.doc"
                  :limit="1"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">(大小&lt;1M 格式.zip.rar.cab.doc)</div>
                </el-upload>
                </el-form-item>
              </el-col>
              <el-input type="textarea" :rows="5" placeholder="请输入备注" v-model="infoForm.Remark">
              </el-input>
            </el-row>
          </el-form>
          <div style="text-align: center;padding-top:20px;">
            <el-button type="primary" @click="submit">提 交</el-button>
          </div>
        </div>

      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import leftmenu from "../components/leftmenu.vue";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "UserCenter",
  components: { leftmenu, leftlogin },
  data() {
    return {
      fileList: [],
      navlist: [{ Word_Text: '个人资料', Word_Value: 1, Id: 1 },
      { Word_Text: '竞价报名', Word_Value: 2, Id: 2 },
      { Word_Text: '竞价大厅', Word_Value: 3, Id: 3 },
      { Word_Text: '竞价历史', Word_Value: 4, Id: 4 }
      ],
      Id: 1,
      form: {

      },
      infoForm: {},
      rules: {}
    };
  },
  created() {
    var that = this;    
    that.getData();
  },
  methods: {
    getData() {
      var that = this;
      var token = window.localStorage.getItem("Token");
      that.$api.get("/User/GetInfoByToken?token=" + token, null, r => {
        that.infoForm = r.response;
      });
    },
    listshow(item) {
      var that = this;
      if (item.Id == 2)
        that.$router.replace("/Enroll");
      if (item.Id == 3)
        that.$router.replace("/Bidding");
      if (item.Id == 4)
        that.$router.replace("/BiddingHistory");
      return false;
    },
    submit() {
      let _this = this;  
      if(_this.infoForm.uLoginPWD && _this.infoForm.uLoginPWD.length < 6){
        _this.$message({
              message: "密码长度必须大于等于6位!",
              type: "error",
            });
        return
      }
      _this.addLoading = true;
        let para = Object.assign({}, this.infoForm);
        _this.$api.put("/User/UserPut", para, res => {
          console.log(res)
          if (res.success) {     
            _this.$message({
              message: "修改成功！",
              type: "success",
            });  
          } else {
            _this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });                  
    },
    updatePWD(){
      let _this = this;  
      if(_this.infoForm.uLoginPWD && _this.infoForm.uLoginPWD.length < 6){
        _this.$message({
              message: "密码长度必须大于等于6位!",
              type: "error",
            });
        return
      }
      _this.addLoading = true;
        let para = Object.assign({}, this.infoForm);
        _this.$api.put("/User/UserUpdatePwd", para, res => {
          console.log(res)
          if (res.success) {     
            _this.$message({
              message: "修改成功！",
              type: "success",
            });  
          } else {
            _this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });  
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleAvatarSuccess(res, file) {
      this.infoForm.Upload_1 = res.response;
      this.$refs.infoForm.clearValidate("Upload_1");
    },
    handleAvatarSuccess2(res, file) {
      this.infoForm.Upload_4 = res.response;
      this.$refs.infoForm.clearValidate("Upload_4");
    },
    handleAvatarSuccess3(res, file) {
      this.infoForm.Upload_5 = res.response;
    },
    Pic_Upload_1(file) {
      this.importFile(file, 1);
    },
    Pic_Upload_4(file) {
      this.importFile(file, 2);
    },
    file_Upload_5(file) {
      if (file.file.size / 1024 / 1024 > 5) {
        this.$message({
          showClose: true,
          message: "上传失败，文件大小请控制在 5M 以内",
          type: "error",
        });
        return;
      }
      var formData = new FormData();
      formData.append("files", file.file);
      var requestConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      this.$api.post(
        "/uploadfile/reg",
        formData,
        (res) => {
          if (res.success) {
            this.$message({
              showClose: true,
              message: "文件上传成功",
              type: "success",
            });
            this.infoForm.upload_5 = res.response;
          } else {
            this.fileList = [];
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
            });
          }
        },
        requestConfig
      );
    },
    importFile(file, num) {
      const isAccord =
        file.file.type === "image/jpeg" ||
        file.file.type === "image/png" ||
        file.file.type === "image/GIF" ||
        file.file.type === "image/jpg" ||
        file.file.type === "image/BMP";
      if (file.file.size / 1024 / 1024 > 2) {
        this.$message({
          showClose: true,
          message: "上传失败，图片大小请控制在 2M 以内",
          type: "error",
        });
        this.clearShowList(file.uid, num);
        return;
      }
      if (file.file.type == isAccord) {
        this.$message({
          showClose: true,
          message: "图片格式错误",
          type: "error",
        });
        this.clearShowList(file.uid, num);
        return;
      }
      var formData = new FormData();
      formData.append("files", file.file);
      var requestConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      this.$api.post(
        "/upload/reg",
        formData,
        (res) => {
          if (res.success) {
            this.$message({
              showClose: true,
              message: "文件上传成功",
              type: "success",
            });
            if (num == 1) {
              this.infoForm.Upload_1 = res.response;
            } else {
              this.infoForm.Upload_4 = res.response;
            }
          } else {
            this.fileList = [];
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
            });
            this.clearShowList(file.uid, num);
          }
        },
        requestConfig
      );
    },
    //清空显示列表
    clearShowList(uid, num) {
      if (num == 1) {
        let idx = this.$refs["Pic_Upload_1"].uploadFiles.findIndex((item) => item.uid === uid);
        this.$refs.Pic_Upload_1.uploadFiles.splice(idx, 1);
      } else {
        let idx = this.$refs["Pic_Upload_4"].uploadFiles.findIndex((item) => item.uid === uid);
        this.$refs.Pic_Upload_4.uploadFiles.splice(idx, 1);
      }
    }
  },
  watch: {
    $route(to) {
    }
  },
  computed: {

  }
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.warp {
  background: #fff;
  padding-top: 20px;
  width: 100%;
  margin: 0 auto;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}</style>
